import { createStore } from 'vuex'
import persistedStateVuex from "persisted-state-vuex"
// import GeoJSON from "ol/format/GeoJSON";
import Api from '@/services/Api'
import agol from "./agol"

export default createStore({
  state: {
    token: null,
    user: null,
    isUserLoggedIn: false,
    routeFeatures: null,
  },
  getters: {
    routeFeatures(state) {
      return state.routeFeatures;
    }
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      state.isUserLoggedIn = !!(token)
    },
    setUser (state, user) {
      state.user = user
    },
    setRouteFeatures(state, features) {
    state.routeFeatures = features;
  },
  },
  actions: {
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    setUser ({commit}, user) {
      commit('setUser', user)
    },
    async fetchRouteFeatures({ commit, state }, { forceReload = false } = {}) {
      if (!forceReload && state.routeFeatures) {
        return state.routeFeatures;
      }

      const res = await Api().get('esri-route-layer');
      // const geojson = new GeoJSON().readFeatures(res.data, {
      //   dataProjection: "EPSG:3857",
      // });

      commit("setRouteFeatures", res.data);
      return res.data;
    },
  },
  modules: {
    agol
  },
  plugins: [persistedStateVuex.init]
})
